import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import appReducer from './slices/appSlice';
import rbacReducer from './slices/rbacSlice';
import filterReducer from './slices/filterSlice';
import filterV2Reducer from './slices/filterSliceV2';
import cmsReducer from './slices/cmsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    app: appReducer,
    rbac: rbacReducer,
    filters: filterReducer,
    filtersV2: filterV2Reducer,
    cms: cmsReducer,
    // Add additional reducers here if needed
  },
});

export default store;
